import { motion } from "framer-motion";
import headshot from "@/assets/ashley-bass-headshot.webp";

const credentials = ["LMFT", "MA in Counseling Psychology", "Somatic Psychology"];

const AboutSection = () => {
  return (
    <section id="about" className="about-section py-24 px-6 bg-background">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="about-heading text-3xl md:text-4xl font-heading font-medium text-foreground mb-4">
            Get to Know Me
          </h2>
          <div className="w-16 h-px bg-accent mx-auto" />
        </motion.div>

        {/* Mobile layout: compact side-by-side top, rest below */}
        <div className="about-grid md:hidden">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="grid grid-cols-[2fr_3fr] gap-4 items-center"
          >
            <div className="relative">
              <div className="absolute -left-3 -top-3 w-full h-full rounded-2xl bg-accent/20" />
              <img
                src={headshot}
                alt="Ashley Bass, therapist at Stillwater Therapy"
                className="about-headshot relative w-full rounded-2xl shadow-lg"
              />
            </div>
            <div className="about-bio space-y-3">
              <h3 className="about-name text-xl font-heading font-medium text-foreground">Ashley Bass</h3>
              <p className="font-body text-muted-foreground font-light leading-relaxed text-sm">
                My therapy journey started many years ago. Having a safe space to explore the difficult questions was
                profoundly impactful on my life. Therapy helped me find myself and return back to a sense of home and
                belonging. And now I have the privilege of helping others take those same steps.
              </p>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="about-bio space-y-5 mt-6"
          >
            <p className="font-body text-muted-foreground font-light leading-relaxed">
              After practicing therapy for nearly a decade, I still consider myself a student of the human
              experience. I am endlessly interested in people – especially how the mind and body work together.
            </p>
            <p className="font-body text-muted-foreground font-light leading-relaxed">
              I founded Stillwater Therapy to help adults, children, and families navigate all sorts of complicated
              experiences – anxiety, depression, trauma, life transitions, and the kinds of struggles that don't always
              have a name. I'd love to meet you and help you be your best self.
            </p>
            <p className="font-body text-foreground font-medium italic">
              "Therapy is one of the bravest things a person can do."
            </p>
            <div className="flex flex-wrap gap-2 pt-2">
              {credentials.map((cred) => (
                <span key={cred} className="px-3 py-1 text-xs font-body font-medium tracking-wide text-accent bg-accent/10 rounded-full">
                  {cred}
                </span>
              ))}
            </div>
          </motion.div>
        </div>

        {/* Tablet/Desktop layout: original asymmetric grid */}
        <div className="about-grid hidden md:grid md:grid-cols-[5fr_7fr] gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="absolute -left-3 -top-3 w-full h-full rounded-2xl bg-accent/20" />
            <img
              src={headshot}
              alt="Ashley Bass, therapist at Stillwater Therapy"
              className="about-headshot relative w-full rounded-2xl shadow-lg"
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="about-bio space-y-5"
          >
            <h3 className="about-name text-2xl font-heading font-medium text-foreground">Ashley Bass</h3>
            <p className="font-body text-muted-foreground font-light leading-relaxed">
              My therapy journey started many years ago. Having a safe space to explore the difficult questions was
              profoundly impactful on my life. Therapy helped me find myself and return back to a sense of home and
              belonging. And now I have the privilege of helping others take those same steps.
            </p>
            <p className="font-body text-muted-foreground font-light leading-relaxed">
              After practicing therapy for nearly a decade, I still consider myself a student of the human
              experience. I am endlessly interested in people – especially how the mind and body work together.
            </p>
            <p className="font-body text-muted-foreground font-light leading-relaxed">
              I founded Stillwater Therapy to help adults, children, and families navigate all sorts of complicated
              experiences – anxiety, depression, trauma, life transitions, and the kinds of struggles that don't always
              have a name. I'd love to meet you and help you be your best self.
            </p>
            <p className="font-body text-foreground font-medium italic">
              "Therapy is one of the bravest things a person can do."
            </p>
            <div className="flex flex-wrap gap-2 pt-2">
              {credentials.map((cred) => (
                <span key={cred} className="px-3 py-1 text-xs font-body font-medium tracking-wide text-accent bg-accent/10 rounded-full">
                  {cred}
                </span>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
